import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SharedModule } from '../shared/shared.module';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
})
export class TestComponent {
 displayedColumns: string[] = [
    'dateTime',
    'nibedonId',
    'name',
    'category',
    'status',
    'poc',
    'pocNumber',
    'actions'
  ];

  dataSource = new MatTableDataSource<Ticket>([
    {
      dateTime: '27/11/22 | 09:36AM',
      nibedonId: 'NIB-1342',
      name: 'Prasannadeep Das',
      category: 'Education',
      status: 'PENDING ON SOLVER',
      poc: 'Sattasundar Parida',
      pocNumber: '+91 - 80064 64672'
    },
    {
      dateTime: '21/11/22 | 11:24AM',
      nibedonId: 'NIB-1339',
      name: 'Pramod Kumar Das',
      category: 'Medical',
      status: 'PENDING ON RESPONDER',
      poc: 'Krutideepak Adhikari',
      pocNumber: '+91 - 94133 961823'
    },
    {
      dateTime: '27/11/22 | 09:36AM',
      nibedonId: 'NIB-1342',
      name: 'Prasannadeep Das',
      category: 'Education',
      status: 'PENDING ON SOLVER',
      poc: 'Sattasundar Parida',
      pocNumber: '+91 - 80064 64672'
    },
    {
      dateTime: '21/11/22 | 11:24AM',
      nibedonId: 'NIB-1339',
      name: 'Pramod Kumar Das',
      category: 'Medical',
      status: 'PENDING ON RESPONDER',
      poc: 'Krutideepak Adhikari',
      pocNumber: '+91 - 94133 961823'
    },
    {
      dateTime: '27/11/22 | 09:36AM',
      nibedonId: 'NIB-1342',
      name: 'Prasannadeep Das',
      category: 'Education',
      status: 'PENDING ON SOLVER',
      poc: 'Sattasundar Parida',
      pocNumber: '+91 - 80064 64672'
    },
    {
      dateTime: '21/11/22 | 11:24AM',
      nibedonId: 'NIB-1339',
      name: 'Pramod Kumar Das',
      category: 'Medical',
      status: 'PENDING ON RESPONDER',
      poc: 'Krutideepak Adhikari',
      pocNumber: '+91 - 94133 961823'
    },
    {
      dateTime: '27/11/22 | 09:36AM',
      nibedonId: 'NIB-1342',
      name: 'Prasannadeep Das',
      category: 'Education',
      status: 'PENDING ON SOLVER',
      poc: 'Sattasundar Parida',
      pocNumber: '+91 - 80064 64672'
    },
    {
      dateTime: '21/11/22 | 11:24AM',
      nibedonId: 'NIB-1339',
      name: 'Pramod Kumar Das',
      category: 'Medical',
      status: 'PENDING ON RESPONDER',
      poc: 'Krutideepak Adhikari',
      pocNumber: '+91 - 94133 961823'
    },
    {
      dateTime: '27/11/22 | 09:36AM',
      nibedonId: 'NIB-1342',
      name: 'Prasannadeep Das',
      category: 'Education',
      status: 'PENDING ON SOLVER',
      poc: 'Sattasundar Parida',
      pocNumber: '+91 - 80064 64672'
    },
    {
      dateTime: '21/11/22 | 11:24AM',
      nibedonId: 'NIB-1339',
      name: 'Pramod Kumar Das',
      category: 'Medical',
      status: 'PENDING ON RESPONDER',
      poc: 'Krutideepak Adhikari',
      pocNumber: '+91 - 94133 961823'
    },
    {
      dateTime: '27/11/22 | 09:36AM',
      nibedonId: 'NIB-1342',
      name: 'Prasannadeep Das',
      category: 'Education',
      status: 'PENDING ON SOLVER',
      poc: 'Sattasundar Parida',
      pocNumber: '+91 - 80064 64672'
    },
    {
      dateTime: '21/11/22 | 11:24AM',
      nibedonId: 'NIB-1339',
      name: 'Pramod Kumar Das',
      category: 'Medical',
      status: 'PENDING ON RESPONDER',
      poc: 'Krutideepak Adhikari',
      pocNumber: '+91 - 94133 961823'
    },
  ]);

  selectedIndex = 0;
  searchText = '';

  tabs = [
    { label: 'Nibedon in Progress', count: 31 },
    { label: 'Solved Responses', count: 119 },
    { label: 'Calls in Queue', count: 5 },
  ];

  onSearchChange(event: any) {
    this.searchText = event.target.value;
    console.log('Search:', this.searchText);
  }
}


interface Ticket {
  dateTime: string;
  nibedonId: string;
  name: string;
  category: string;
  status: string;
  poc: string;
  pocNumber: string;
}